import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { Input, Textarea } from "./ui";

export function ListEditor({ value = [], onChange, placeholder = "Add item", testId }) {
    const set = (i, v) => onChange(value.map((x, idx) => (idx === i ? v : x)));
    return (
        <div className="space-y-2" data-testid={testId}>
            {value.map((v, i) => (
                <div key={i} className="flex gap-2">
                    <Input value={v} placeholder={placeholder} onChange={(e) => set(i, e.target.value)} />
                    <button type="button" onClick={() => onChange(value.filter((_, idx) => idx !== i))}
                        className="px-3 border border-white/12 text-zinc-500 hover:text-red-400">
                        <Trash2 className="w-4 h-4" />
                    </button>
                </div>
            ))}
            <button type="button" onClick={() => onChange([...value, ""])}
                className="inline-flex items-center gap-1.5 mono text-[10px] tracking-[0.16em] text-gold">
                <Plus className="w-3.5 h-3.5" /> ADD
            </button>
        </div>
    );
}

export function RowEditor({ value = [], onChange, fields = [], testId }) {
    const blank = fields.reduce((a, f) => ({ ...a, [f.key]: "" }), {});
    const set = (i, key, v) => onChange(value.map((row, idx) => (idx === i ? { ...row, [key]: v } : row)));
    return (
        <div className="space-y-3" data-testid={testId}>
            {value.map((row, i) => (
                <div key={i} className="border border-white/10 p-3">
                    <div className="grid md:grid-cols-2 gap-3">
                        {fields.map((f) => (
                            <div key={f.key} className={f.wide ? "md:col-span-2" : ""}>
                                <span className="mono text-[9px] tracking-[0.16em] text-zinc-500">{f.label}</span>
                                {f.type === "textarea" ? (
                                    <Textarea rows={3} className="mt-1" value={row[f.key] || ""}
                                        onChange={(e) => set(i, f.key, e.target.value)} />
                                ) : (
                                    <Input className="mt-1" value={row[f.key] || ""} placeholder={f.placeholder || ""}
                                        onChange={(e) => set(i, f.key, e.target.value)} />
                                )}
                            </div>
                        ))}
                    </div>
                    <button type="button" onClick={() => onChange(value.filter((_, idx) => idx !== i))}
                        className="mt-2 inline-flex items-center gap-1.5 mono text-[9px] tracking-[0.16em] text-red-400">
                        <Trash2 className="w-3.5 h-3.5" /> REMOVE
                    </button>
                </div>
            ))}
            <button type="button" onClick={() => onChange([...value, blank])}
                className="inline-flex items-center gap-1.5 mono text-[10px] tracking-[0.16em] text-gold">
                <Plus className="w-3.5 h-3.5" /> ADD ROW
            </button>
        </div>
    );
}
